import { render, staticRenderFns } from "./ApplicationUploadsReview.vue?vue&type=template&id=09fe892d&scoped=true&"
import script from "./ApplicationUploadsReview.vue?vue&type=script&lang=js&"
export * from "./ApplicationUploadsReview.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationUploadsReview.vue?vue&type=style&index=0&id=09fe892d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fe892d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAvatar,VCard,VCardText,VCol,VIcon,VRow,VToolbar,VToolbarTitle})
